import React from 'react';
import { useTranslation } from '@refinedev/core';
import { Button, Dropdown, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { DirectionType } from 'antd/es/config-provider/context';
import useLangStore from '@/core/lang';
import { EnglishFlag, QatarFlag } from '../../../assets/icons';
import { MenuProps } from 'antd/es/menu';
export const LanguageSwitcher: React.FC = () => {
  const { changeLocale, getLocale } = useTranslation();
  const currentLocale = getLocale();
  const { setLocale } = useLangStore();
  const changeDirection = (lang: string) => {
    changeLocale(lang);
    setLocale(lang);
    const newDirection: DirectionType = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.dir = newDirection;
    localStorage.setItem('direction', newDirection);
  };

  const menu: MenuProps['items'] = [
    {
      label: 'English',
      key: 'en',
      icon: <EnglishFlag width={16} height={16} />,
      onClick: () => changeDirection('en'),
    },
    {
      label: 'العربية',
      key: 'ar',
      icon: <QatarFlag width={16} height={16} />,
      onClick: () => changeDirection('ar'),
    },
  ];

  return (
    <Dropdown menu={{ items: menu }}>
      <Button>
        <Space>
          {currentLocale === 'en' ? (
            <EnglishFlag width={16} height={16} />
          ) : (
            <QatarFlag width={16} height={16} />
          )}
          {currentLocale === 'en' ? 'English' : 'العربية'}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  );
};
